
export var VcPrettyNumberFormatter = (function () {
	
    
    return {
        format:function(d) {
            var absd=Math.abs(d);
            if (absd<2000) return d;
            if (absd<1000000) {
                return (d/1000).toFixed(1)+"k";
            } else {
                return (d/1000000).toFixed(1)+"M";
            } 
        }
    }
}());
